import React, { useState } from 'react';
import { X } from 'lucide-react';
type ModalType = 'privacy' | 'terms' | null;
export function SalesFooter() {
  const [activeModal, setActiveModal] = useState<ModalType>(null);
  return <>
      <footer className="bg-brand-navy-light text-gray-400 py-12 px-4 text-center font-body text-sm border-t border-gray-800" data-id="element-139">
        <div className="max-w-4xl mx-auto space-y-6" data-id="element-140">
          <p className="font-heading text-2xl text-brand-gold font-bold" data-id="element-141">
            La Jefa de su Crédito
          </p>
          <p data-id="element-142">
            DESCARGO DE RESPONSABILIDAD: Los resultados mostrados no son típicos
            y variarán según su situación crediticia individual. Este producto
            proporciona información educativa y plantillas, no asesoramiento
            legal. No garantizamos la eliminación de deudas legítimas ni un
            aumento específico en su puntaje de crédito.
          </p>
          <div className="flex items-center justify-center gap-6" data-id="element-143">
            <button onClick={() => setActiveModal('privacy')} className="text-gray-400 hover:text-brand-gold underline underline-offset-4 transition-colors duration-200" data-id="element-144">
              Política de Privacidad
            </button>
            <span className="text-gray-600" data-id="element-145">|</span>
            <button onClick={() => setActiveModal('terms')} className="text-gray-400 hover:text-brand-gold underline underline-offset-4 transition-colors duration-200" data-id="element-146">
              Términos y Condiciones
            </button>
          </div>
          <p data-id="element-147">
            © {new Date().getFullYear()} La Jefa de su Crédito. Todos los
            derechos reservados.
          </p>
        </div>
      </footer>

      {/* Modal Overlay */}
      {activeModal && <div className="fixed inset-0 z-50 flex items-center justify-center p-4 bg-black/70 backdrop-blur-sm" onClick={() => setActiveModal(null)} data-id="element-148">
          <div className="bg-white rounded-2xl shadow-2xl w-full max-w-2xl max-h-[85vh] overflow-hidden flex flex-col" onClick={e => e.stopPropagation()} data-id="element-149">
            {/* Modal Header */}
            <div className="flex items-center justify-between px-6 py-5 border-b border-gray-200 bg-brand-navy" data-id="element-150">
              <h2 className="font-heading text-xl font-bold text-brand-gold" data-id="element-151">
                {activeModal === 'privacy' ? 'Política de Privacidad' : 'Términos y Condiciones'}
              </h2>
              <button onClick={() => setActiveModal(null)} className="text-gray-300 hover:text-white transition-colors p-1" aria-label="Cerrar" data-id="element-152">
                <X className="w-6 h-6" data-id="element-153" />
              </button>
            </div>

            {/* Modal Body */}
            <div className="overflow-y-auto px-6 py-8 font-body text-gray-700 text-sm leading-relaxed space-y-6" data-id="element-154">
              {activeModal === 'privacy' ? <PrivacyContent data-id="element-155" /> : <TermsContent data-id="element-156" />}
            </div>

            {/* Modal Footer */}
            <div className="px-6 py-4 border-t border-gray-200 bg-gray-50 text-center" data-id="element-157">
              <button onClick={() => setActiveModal(null)} className="bg-brand-navy text-white font-bold py-2 px-8 rounded-lg hover:bg-brand-navy-light transition-colors duration-200 text-sm" data-id="element-158">
                Cerrar
              </button>
            </div>
          </div>
        </div>}
    </>;
}
function PrivacyContent() {
  return <>
      <p className="text-gray-500 text-xs" data-id="element-159">
        Última actualización:{' '}
        {new Date().toLocaleDateString('es-US', {
        year: 'numeric',
        month: 'long',
        day: 'numeric'
      })}
      </p>

      <h3 className="font-heading text-lg font-bold text-brand-navy" data-id="element-160">
        1. Información que Recopilamos
      </h3>
      <p data-id="element-161">
        Al adquirir nuestro producto digital, recopilamos la información
        necesaria para procesar tu compra, incluyendo tu nombre, dirección de
        correo electrónico y datos de pago. No almacenamos información de
        tarjetas de crédito directamente; todos los pagos son procesados a
        través de plataformas de pago seguras de terceros.
      </p>

      <h3 className="font-heading text-lg font-bold text-brand-navy" data-id="element-162">
        2. Uso de la Información
      </h3>
      <p data-id="element-163">
        Utilizamos tu información personal exclusivamente para: entregar el
        producto digital adquirido, enviarte actualizaciones relacionadas con tu
        compra, y mejorar nuestros servicios. No vendemos, alquilamos ni
        compartimos tu información personal con terceros para fines de
        marketing.
      </p>

      <h3 className="font-heading text-lg font-bold text-brand-navy" data-id="element-164">
        3. Protección de Datos
      </h3>
      <p data-id="element-165">
        Implementamos medidas de seguridad técnicas y organizativas para
        proteger tu información personal contra acceso no autorizado,
        alteración, divulgación o destrucción. Utilizamos cifrado SSL para todas
        las transmisiones de datos.
      </p>

      <h3 className="font-heading text-lg font-bold text-brand-navy" data-id="element-166">
        4. Cookies
      </h3>
      <p data-id="element-167">
        Nuestro sitio web puede utilizar cookies para mejorar tu experiencia de
        navegación y analizar el tráfico del sitio. Puedes configurar tu
        navegador para rechazar cookies, aunque esto podría afectar la
        funcionalidad del sitio.
      </p>

      <h3 className="font-heading text-lg font-bold text-brand-navy" data-id="element-168">
        5. Tus Derechos
      </h3>
      <p data-id="element-169">
        Tienes derecho a acceder, corregir o eliminar tu información personal en
        cualquier momento. Para ejercer estos derechos, puedes comunicarte con
        nosotros a través de los canales disponibles en nuestro sitio web.
      </p>

      <h3 className="font-heading text-lg font-bold text-brand-navy" data-id="element-170">
        6. Cambios a esta Política
      </h3>
      <p data-id="element-171">
        Nos reservamos el derecho de actualizar esta política de privacidad en
        cualquier momento. Los cambios serán publicados en esta página con la
        fecha de actualización correspondiente.
      </p>
    </>;
}
function TermsContent() {
  return <>
      <p className="text-gray-500 text-xs" data-id="element-172">
        Última actualización:{' '}
        {new Date().toLocaleDateString('es-US', {
        year: 'numeric',
        month: 'long',
        day: 'numeric'
      })}
      </p>

      <h3 className="font-heading text-lg font-bold text-brand-navy" data-id="element-173">
        1. Aceptación de los Términos
      </h3>
      <p data-id="element-174">
        Al comprar y acceder al producto digital "La Jefa de su Crédito",
        aceptas estos términos y condiciones en su totalidad. Si no estás de
        acuerdo con alguno de estos términos, no debes adquirir ni utilizar este
        producto.
      </p>

      <h3 className="font-heading text-lg font-bold text-brand-navy" data-id="element-175">
        2. Naturaleza del Producto
      </h3>
      <p data-id="element-176">
        Este es un producto educativo e informativo. Las plantillas, guías y
        materiales proporcionados tienen fines exclusivamente educativos. No
        constituyen asesoramiento legal, financiero ni crediticio profesional.
        Los resultados pueden variar según la situación individual de cada
        persona.
      </p>

      <h3 className="font-heading text-lg font-bold text-brand-navy" data-id="element-177">
        3. Licencia de Uso
      </h3>
      <p data-id="element-178">
        Al completar tu compra, recibes una licencia personal e intransferible
        para usar los materiales incluidos. No está permitido copiar,
        distribuir, revender ni compartir el contenido con terceros sin
        autorización expresa por escrito.
      </p>

      <h3 className="font-heading text-lg font-bold text-brand-navy" data-id="element-179">
        4. Entrega del Producto
      </h3>
      <p data-id="element-180">
        El producto digital se entrega de forma instantánea tras la confirmación
        del pago. Recibirás acceso inmediato a todos los materiales incluidos en
        el kit a través del correo electrónico proporcionado durante la compra.
      </p>

      <h3 className="font-heading text-lg font-bold text-brand-navy" data-id="element-181">
        5. Política de Reembolso
      </h3>
      <p data-id="element-182">
        Debido a la naturaleza digital e instantánea del producto, todas las
        ventas son finales. Sin embargo, si experimentas problemas técnicos para
        acceder al contenido, trabajaremos contigo para resolver cualquier
        inconveniente.
      </p>

      <h3 className="font-heading text-lg font-bold text-brand-navy" data-id="element-183">
        6. Limitación de Responsabilidad
      </h3>
      <p data-id="element-184">
        No garantizamos resultados específicos en la reparación de crédito. Los
        resultados dependen de múltiples factores individuales, incluyendo tu
        historial crediticio, las acciones que tomes y la respuesta de los burós
        de crédito. No somos responsables por decisiones tomadas basándose en el
        contenido de este producto.
      </p>

      <h3 className="font-heading text-lg font-bold text-brand-navy" data-id="element-185">
        7. Propiedad Intelectual
      </h3>
      <p data-id="element-186">
        Todo el contenido, incluyendo textos, plantillas, diseños y materiales,
        es propiedad exclusiva de La Jefa de su Crédito y está protegido por las
        leyes de propiedad intelectual aplicables.
      </p>

      <h3 className="font-heading text-lg font-bold text-brand-navy" data-id="element-187">
        8. Modificaciones
      </h3>
      <p data-id="element-188">
        Nos reservamos el derecho de modificar estos términos en cualquier
        momento. Las modificaciones entrarán en vigor inmediatamente después de
        su publicación en el sitio web.
      </p>
    </>;
}